module.exports = __webpack_public_path__ + "static/media/hangman07.a4dde311.svg";